import React, {useCallback, useEffect, useMemo, useState, useRef} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import $ from 'jquery';

import {Container, TrialSidebarNotice} from "./styles";
import logo from "../../../assets/img/logo.png";
import {useDispatch, useSelector} from "react-redux";
import {actions} from "../../../redux/actions";
import swal from "@sweetalert/with-react";
import {getSignature, testSignature} from "../../../services/Profile";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import {useTranslation} from "react-i18next";
import {FaHandshake} from "react-icons/fa";
import {GiReceiveMoney} from "react-icons/gi";
import {GoChecklist} from "react-icons/go";
import {daysRemainingFromSignatureIso, signatureDueDateToIso} from "../../../utils/signatureDueDate";

export default function Sidebar() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const sidebarRef = useRef(null);
    const { t } = useTranslation();

    /** Submenu acordeão (Relatórios / Afiliados admin): quando aberto, só ele fica .active — evita dois destaques. */
    const [expandedSidebarCollapse, setExpandedSidebarCollapse] = useState(null);

    const navIsActive = (path) => {
        if (path === '/dashboard') {
            return location.pathname === '/dashboard';
        }
        return location.pathname.startsWith(path);
    };

    const reportSectionActive =
        navIsActive('/disciplina/report') ||
        location.pathname.startsWith('/trading/report') ||
        location.pathname === '/placar';

    const affiliateAdminActive = location.pathname.startsWith('/admin/affiliate-program');

    const {menuOpen} = useSelector(
        (state) => state.MenuOpenReducer
    );

    const {id, meta} = useSelector(
        (state) => state.BankReducer
    );

    const {isActiveSignature, isEnableFreeSignature, roles, isFreeSignature, dueDate} = useSelector(
        (state) => state.UserReducer
    );

    const handleActiveSignatureFree = useCallback((redirectUrl) => {
        if (isEnableFreeSignature) {
            testSignature().then(() => {
                getSignature().then((data) => {
                    if (!data) {
                        return;
                    }
                    dispatch(actions.setActiveSignature(data.data.isSignatureActive));
                    dispatch(actions.setIsEnableFreeSignature(data.data.isEnableFreeSignature));
                    dispatch(actions.setIsFreeSignature(data.data.isFree));
                    dispatch(actions.setDueDateSignature(signatureDueDateToIso(data.data.dueDate)));
                });
            });
        }
    }, [isEnableFreeSignature, dispatch]);

    useEffect(handleActiveSignatureFree, [isEnableFreeSignature]);

    useEffect(() => {
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        const isSidebarOpenOnMobile = isMobile && !menuOpen;
        if (!isSidebarOpenOnMobile) return;

        const handlePointerDownCapture = (event) => {
            const sidebarEl = sidebarRef.current;
            if (!sidebarEl) return;
            if (sidebarEl.contains(event.target)) return;

            const sidebarToggle = document.getElementById('sidebarToggle');
            if (sidebarToggle && sidebarToggle.contains(event.target)) return;

            const sidebarToggleTop = document.getElementById('sidebarToggleTop');
            if (sidebarToggleTop && sidebarToggleTop.contains(event.target)) return;

            dispatch(actions.clickMenuOpen());
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                dispatch(actions.clickMenuOpen());
            }
        };

        document.addEventListener('mousedown', handlePointerDownCapture, true);
        document.addEventListener('touchstart', handlePointerDownCapture, true);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('mousedown', handlePointerDownCapture, true);
            document.removeEventListener('touchstart', handlePointerDownCapture, true);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [menuOpen, dispatch]);

    useEffect(() => {
        if (!$ || !$.fn || !$.fn.collapse) return undefined;

        const onShown = (e) => {
            const id = e.target.id;
            if (id === 'collapseAffiliate') setExpandedSidebarCollapse('affiliate');
            else if (id === 'collapseReport') setExpandedSidebarCollapse('report');
        };

        const onHidden = (e) => {
            const id = e.target.id;
            setExpandedSidebarCollapse((prev) => {
                if (id === 'collapseAffiliate' && prev === 'affiliate') return null;
                if (id === 'collapseReport' && prev === 'report') return null;
                return prev;
            });
        };

        const $aff = $('#collapseAffiliate');
        const $rep = $('#collapseReport');
        if (!$aff.length && !$rep.length) return undefined;

        $aff.on('shown.bs.collapse', onShown);
        $aff.on('hidden.bs.collapse', onHidden);
        $rep.on('shown.bs.collapse', onShown);
        $rep.on('hidden.bs.collapse', onHidden);

        return () => {
            $aff.off('shown.bs.collapse', onShown).off('hidden.bs.collapse', onHidden);
            $rep.off('shown.bs.collapse', onShown).off('hidden.bs.collapse', onHidden);
        };
    }, []);

    useEffect(() => {
        setExpandedSidebarCollapse(null);
        if ($ && $.fn && $.fn.collapse) {
            $('#collapseAffiliate, #collapseReport').collapse('hide');
        }
    }, [location.pathname]);

    const handleRedirectUrl = useCallback((redirectUrl) => {
        const canNavigate = isActiveSignature === true || isEnableFreeSignature === true;
        if (canNavigate) {
            history.push(redirectUrl);
            return;
        }

        swal(
            {
                icon: "info",
                text: t('alert_signature'),
                buttons: [t('alert_signature_btn_close'), t('alert_signature_confirm')],
            }
        ).then((isConfirm) => {
            if (isConfirm) {
                history.push('/plans');
            }
        });

    }, [isActiveSignature, isEnableFreeSignature, history, t]);

    async function handleTestSignature() {
        try {
            setLoading(true);
            await testSignature();
            window.location.href = '/dashboard';
        } catch (err) {
            setLoading(false);
            toast.error(messageTypes.ERROR_TEST_SIGNATURE);
        }
    }

    const routeHighlightsActive = expandedSidebarCollapse === null;
    const activeFromRoute = (flag) => !!flag && routeHighlightsActive;

    const trialDaysRemaining = useMemo(() => {
        if (isFreeSignature !== true) {
            return null;
        }
        return daysRemainingFromSignatureIso(dueDate);
    }, [isFreeSignature, dueDate]);

    return (
        <Container
            ref={sidebarRef}
            className={menuOpen ? 'navbar-nav sidebar sidebar-dark accordion toggled' : 'navbar-nav sidebar sidebar-dark accordion'}
            id="accordionSidebar">

            {/* <!-- Sidebar - Brand --> */}
            <Link className="sidebar-brand d-flex align-items-center mt-4 mb-4 justify-content-center" to="/dashboard">
                <div className="sidebar-brand-icon">
                    <img width={menuOpen ? 70 : 140} src={logo} alt="GBinary"/>
                </div>
            </Link>

            {/* <!-- Divider --> */}
            <hr className="sidebar-divider my-0"/>

            {isFreeSignature === true && (
                <li className="nav-item px-2">
                    <TrialSidebarNotice aria-label={t('trial_subscription_tooltip')}>
                        <div className="trial-sidebar-heading">
                            <i className="fas fa-flask trial-sidebar-icon" aria-hidden/>
                            <span>{t('badge_trial_subscription')}</span>
                        </div>
                        <div className="trial-sidebar-help">{t('trial_subscription_sidebar_help')}</div>
                        {trialDaysRemaining !== null && (
                            <div className="trial-sidebar-days">
                                {trialDaysRemaining === 0
                                    ? t('trial_days_remaining_today')
                                    : trialDaysRemaining === 1
                                        ? t('trial_days_remaining_one', {count: 1})
                                        : t('trial_days_remaining_other', {count: trialDaysRemaining})}
                            </div>
                        )}
                        <Link className="trial-sidebar-link" to="/plans">
                            {t('navbar_plans')}
                        </Link>
                    </TrialSidebarNotice>
                </li>
            )}

            {/* <!-- Nav Item - Dashboard --> */}
            {(id !== 0 && id !== null) && <>
                <li className={`nav-item ${activeFromRoute(navIsActive('/dashboard')) ? 'active' : ''}`}>
                    <Link className="nav-link" to="/dashboard">
                        <div className="nav-dashboard">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>Dashboard</span>
                        </div>
                    </Link>
                </li>
                <hr className="sidebar-divider"/>
                <li className={`nav-item ${activeFromRoute(navIsActive('/bank/view')) ? 'active' : ''}`}>
                    <Link className='nav-link' to="/bank/view">
                        <div className="nav-bank">
                            <i className="fas fa-wallet"></i>
                            <span>{t('navbar_bank')}</span>
                        </div>
                    </Link>
                </li>
                <li className={`nav-item ${activeFromRoute(navIsActive('/calc')) ? 'active' : ''}`}>
                    <div
                      style={{cursor: 'pointer'}}
                      className='nav-link'
                      onClick={() => {
                          handleRedirectUrl('/calc');
                      }}
                    >
                        <div>
                            <i className="fa fa-calculator" aria-hidden="true"></i>
                            <span>{t('navbar_calc')}
                                {!isActiveSignature && <>
                                    <small className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                </>}
                            </span>
                        </div>
                    </div>
                </li>
                <li className={`nav-item ${activeFromRoute(navIsActive('/economic-calendar')) ? 'active' : ''}`}>
                    <div
                      className='nav-link'
                      onClick={() => {
                          handleRedirectUrl('/economic-calendar');
                      }}
                      style={{cursor: 'pointer'}}
                    >
                        <div className="nav-economic-calendar">
                            <i className="fa fa-calendar-day"></i>
                            <span>
                                {t('navbar_calendar')}
                                {!isActiveSignature && <>
                                    <small className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                </>}
                            </span>
                        </div>
                    </div>
                </li>
                <li className={`nav-item ${activeFromRoute(navIsActive('/estrategias')) ? 'active' : ''}`}>
                    <div
                      className='nav-link'
                      onClick={() => {
                          handleRedirectUrl('/estrategias');
                      }}
                      style={{cursor: 'pointer'}}
                    >
                        <div className="nav-strategy">
                            <i className="fa fa-list" aria-hidden="true"></i>
                            <span>
                                {t('navbar_strategies')}
                                {!isActiveSignature && <>
                                    <small className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                </>}
                            </span>
                        </div>
                    </div>
                </li>
                <li className={`nav-item ${activeFromRoute(navIsActive('/meta')) ? 'active' : ''}`}>
                    <div
                      className='nav-link'
                      onClick={() => {
                          handleRedirectUrl(meta ? '/meta' : '/meta/save');
                      }}
                      style={{cursor: 'pointer'}}
                    >
                        <div className="nav-meta">
                            <i className="fa fa-check-square" aria-hidden="true"></i>
                            <span>
                                {t('navbar_meta')}
                                {!isActiveSignature && <>
                                    <small className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                </>}
                            </span>
                        </div>
                    </div>
                </li>
                <li className={`nav-item ${activeFromRoute(location.pathname === '/disciplina') ? 'active' : ''}`}>
                    <div
                      className='nav-link'
                      onClick={() => {
                          handleRedirectUrl('/disciplina');
                      }}
                      style={{cursor: 'pointer'}}
                    >
                        <div className="nav-disciplina">
                            <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                            <span>
                                {t('navbar_disciplina')}
                                {!isActiveSignature && <>
                                    <small className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                </>}
                            </span>
                        </div>
                    </div>
                </li>

                <li className={`nav-item ${activeFromRoute(location.pathname === '/trading') ? 'active' : ''}`}>
                    <Link className='nav-link' to="/trading">
                        <div className="nav-trading">
                            <i className="fas fa-chart-bar"></i>
                            <span>{t('navbar_tradings')}</span>
                        </div>
                    </Link>
                </li>
                {roles && roles.includes('ROLE_ADMIN') ? <>
                    <li className={`nav-item ${(affiliateAdminActive && routeHighlightsActive) || expandedSidebarCollapse === 'affiliate' ? 'active' : ''}`}>
                        <a className="nav-link collapsed" href="#" data-toggle="collapse"
                           data-target="#collapseAffiliate"
                           aria-expanded="false" aria-controls="collapseConfig">
                            <i className="fa fa-users"></i>
                            <span>Programa de afiliados</span>
                        </a>
                        <div id="collapseAffiliate" className="collapse" aria-labelledby="collapseAffiliate"
                             data-parent="#accordionSidebar">
                            <div className="py-2 collapse-inner rounded">
                                <div className='collapse-item cursor-pointer' onClick={() => {
                                    handleRedirectUrl('/admin/affiliate-program/affiliates');
                                }}>
                                    <div className="">
                                        <FaHandshake size={18}/> Afiliados
                                    </div>
                                </div>
                                <div className='collapse-item cursor-pointer' onClick={() => {
                                    handleRedirectUrl('/admin/affiliate-program/commissions');
                                }}>
                                    <div className="r">
                                        <GiReceiveMoney size={18}/> <span>Comissões</span>
                                    </div>
                                </div>
                                <div className='collapse-item cursor-pointer' onClick={() => {
                                    handleRedirectUrl('/admin/affiliate-program/commission/payment/list');
                                }}>
                                    <div className="r">
                                        <GoChecklist size={18}/> <span>Pagamentos</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </> : <>
                    <li className={`nav-item ${activeFromRoute(navIsActive('/affiliate-program')) ? 'active' : ''}`}>
                        <Link className='nav-link' to="/affiliate-program">
                            <div className="">
                                <i className="fa fa-users"></i>
                                <span>Programa de afiliados</span>
                            </div>
                        </Link>
                    </li>
                </>}
                {(!isActiveSignature || isFreeSignature === true) && <>
                    <li className={`nav-item ${activeFromRoute(navIsActive('/plans')) ? 'active' : ''}`}>
                        <Link className='nav-link' to="/plans">
                            <div>
                                <i className="fa fa-list-ul" aria-hidden="true"></i>
                                <span>{t('navbar_plans')}</span>
                            </div>
                        </Link>
                    </li>
                </>}
                <li className={`nav-item ${(reportSectionActive && routeHighlightsActive) || expandedSidebarCollapse === 'report' ? 'active' : ''}`}>
                    <a className="nav-link collapsed nav-report" href="#" data-toggle="collapse"
                       data-target="#collapseReport"
                       aria-expanded="false" aria-controls="collapseConfig">
                        <i className="far fa-file-alt"></i>
                        <span>{t('navbar_report')}</span>
                    </a>
                    <div id="collapseReport" className="collapse" aria-labelledby="collapseReport"
                         data-parent="#accordionSidebar">
                        <div className="py-2 collapse-inner rounded">
                            <div className='collapse-item cursor-pointer' onClick={() => {
                                handleRedirectUrl('/disciplina/report');
                            }}>
                                <div className="">
                                    <i className="fa fa-graduation-cap" aria-hidden="true" style={{ fontSize: 18 }}></i>
                                    <span> {t('navbar_report_disciplina')}</span>
                                    {!isActiveSignature && <>
                                        <small
                                          className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                    </>}
                                </div>
                            </div>
                            <div className='collapse-item cursor-pointer' onClick={() => {
                                handleRedirectUrl('/trading/report-performance');
                            }}>
                                <div className="r">
                                    <i className="fas fa-chart-line" style={{ fontSize: 18 }}></i>
                                    <span> {t('navbar_report_performance')}</span>
                                    {!isActiveSignature && <>
                                        <small
                                          className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                    </>}
                                </div>
                            </div>
                            <div className='collapse-item cursor-pointer' onClick={() => {
                                handleRedirectUrl('/placar');
                            }}>
                                <div className="r">
                                    <i className="fa fa-list-ul" style={{ fontSize: 18 }}></i>
                                    <span> {t('navbar_report_history')}</span>
                                    {!isActiveSignature && <>
                                        <small
                                          className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                    </>}
                                </div>
                            </div>
                            <div className='collapse-item cursor-pointer' onClick={() => {
                                handleRedirectUrl('/trading/report');
                            }}>
                                <div className="r">
                                    <i className="fas fa-chart-bar" style={{ fontSize: 18 }}></i>
                                    <span> {t('navbar_report_tradings')}</span>
                                    {!isActiveSignature && <>
                                        <small
                                          className="badge badge-success pl-2 pr-2 font-weight-bolder ml-2">PRO</small>
                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <hr className="sidebar-divider d-none d-md-block"/>
                {!isActiveSignature && !loading && isEnableFreeSignature && <>
                    {!menuOpen ?
                      <>
                          <div className="d-none d-md-inline text-center mt-4 ml-3 mr-3 rounded"
                               style={{color: 'rgba(255, 255, 255, 0.8)', backgroundColor: 'rgba(0,0,0,.1)'}}>
                              <div className={"pl-2 pr-2 pt-3 pb-3"}>
                                  <p className="text-center small">
                                      {t('navbar_test_free')}
                                  </p>
                                  <div className="btn btn-success btn-sm font-weight-bold"
                                       onClick={handleTestSignature}>
                                      {t('navbar_btn_test')}
                                  </div>
                              </div>
                          </div>
                      </> :
                      <>
                          <div className="d-none d-md-inline text-center mt-4 ml-3 mr-3  mb-5"
                               style={{color: 'rgba(255, 255, 255, 0.8)'}}>
                              <div className={"pl-2 pr-2 pt-3"}>
                                  <div className="btn btn-success btn-sm font-weight-bold"
                                       onClick={handleTestSignature}>
                                      {t('navbar_btn_test')}
                                  </div>
                              </div>
                          </div>
                      </>
                    }
                </>}
            </>}
            <div className="text-center d-none d-md-inline">
                <button onClick={() => {
                    dispatch(actions.clickMenuOpen());
                }} className="rounded-circle border-0" id="sidebarToggle"></button>
            </div>
        </Container>
    )
}